export const MAX_CHARS = 800
export const MAX_FILES = 5
export const MAX_FILE_SIZE_MB = 50
export const ALLOWED_TYPES = [
    // images
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/gif',
    'image/heic',
    'image/heif',

    // video
    'video/mp4',
    'video/webm',
    'video/quicktime'
]
